import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";
import clsx from "clsx";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import MainLayout from "../layouts/MainLayout";
import Promo from "../components/Promo";
import IntroVideo from "../components/IntroVideo";
import { usePublicTemplateList } from "../api/hooks/public-templates";
import { useProfile, useFetchDashboardStats } from "../api/hooks/profile";
import { useFetchPlanById } from "../api/hooks/stripe";
import { MiniTemplateItem } from "./templates/TemplateListHome";
import UploadPDFContainer from "../containers/UploadPDF";
import UploadPdfModal from "../components/UploadPdfModal";
import DemoFormContainer from "../components/DemoForm";

import templatesIcon from "../images/pdf/file-docs.svg";
import signImg from "../images/home/Imgen_firma.png";
import templateImg from "../images/home/Plantilla_Dash.svg";
import { useTranslation } from "react-i18next";
import { getPrice } from "../utils";
import "../scss/home.scss";
function Home() {
  const { t } = useTranslation("common");
  const { profile } = useProfile();
  const showRequestDemo = ["premium", "basic"].includes(profile?.plan?.type);

  return (
    <MainLayout>
      <Container>
        <IntroVideo />
        <Row>
          <Col lg={8}>
            <Row className="h-100">
              <Col sm={12}>
                <UploadDocument className="mt-2 h-100" />
              </Col>
              <Col className="mt-4" sm={12}>
                <CreateYourFirstDocument />
              </Col>
            </Row>
          </Col>
          <Col lg={4}>
            <Row className="h-100">
              <Col className="mt-5 mt-lg-0" lg={12}>
                {showRequestDemo ? <RequestDemo /> : <UpgradePlan />}
              </Col>
              <Col className="mt-4" lg={12}>
                <PopularTemplatesContainer className="mt-2 h-100" />
              </Col>
            </Row>
          </Col>
          {/* <Col md={6}>
            <Card className="mx-auto border-0 shadow-sm h-100">
              <CardBody className="text-center pt-4 px-5 pb-5">
                <h2 className="font-weight-bold mb-0">{t('useTemplate.title')}</h2>
                <p className="text-muted">{t('useTemplate.subtitle')}</p>
                <p className="text-muted">{t('useTemplate.subtitle2')}</p>
                  <div className="custom-file-upload">
                    
                      <Link to="/templates/catalog">
                        <div className="upload-photo border-0">    
                            <img src={templatesIcon} className="img-fluid icon mb-4" alt="upload file" />
                            <p className="text-muted mb-3">{t('useTemplate.selectOne')}</p>
                            <Button tag={Link} to="/templates/catalog" color="primary-gradient" className="shadow-sm">{t('actions.viewTemplate', {count: 2})}</Button>
                            <input type="file" name="photo" id="upload-photo" />
                        </div>
                      </Link>
                  </div>
                
              </CardBody>
            </Card>
          </Col> */}
        </Row>
        <Row className="mt-5">
          <Promo />
        </Row>
      </Container>
    </MainLayout>
  );
}

export default Home;

function CreateYourFirstDocument({ className }) {
  const { t } = useTranslation("common");
  return (
    <div className={clsx("bg-white rounded-lg p-4", className)}>
      <div className="mt-2 mx-2">
        <h3 className="font-size-32 font-weight-bold">
          {t("homePage.box1.title")}
        </h3>
      </div>
      <div className="d-flex justify-content-center p-2 mt-5">
        <img className="w-75" src={templateImg} height="200px" alt="" />
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center mt-5 mb-2">
        <Link
          className="font-size-20"
          component={Button}
          to="/templates/catalog"
          color="accent-100"
        >
          {t("homePage.box1.button")}
        </Link>
        <Link
          className="text-underline mt-5 font-size-20 font-weight-bold"
          to="/tutorials"
        >
          {t("homePage.box1.button2")}
        </Link>
      </div>
    </div>
  );
}
function DashboardStats({ className }) {
  const { isLoading, data = {} } = useFetchDashboardStats();

  return (
    <Row className={clsx("", className)}>
      <Col md={4}>
        <DashboardStatsItem
          label="Total de Documentos"
          total={data.totalDocuments}
          count={data.totalDocumentsThisMonth}
          countLabel="Nuevos"
        />
      </Col>
      <Col md={4}>
        <DashboardStatsItem
          label="Documentos Firmados"
          total={data.signedDocuments}
          count={data.signedDocumentsThisMonth}
          countLabel="Nuevos"
        />
      </Col>
      <Col md={4}>
        <DashboardStatsItem
          label="Mis Plantillas"
          total={data.totalTemplates}
          count={data.totalTemplatesThisMonth}
          countLabel="Nuevas"
        />
      </Col>
    </Row>
  );
}

function DashboardStatsItem({ label, total = 0, count = 0, countLabel }) {
  return (
    <div className="bg-white rounded p-4">
      <div className="d-flex justify-content-between">
        <span className="font-weight-bold font-size-14">{label}</span>
        <FontAwesomeIcon icon="chevron-right" />
      </div>
      <div className="d-flex justify-content-between align-items-end">
        <span className="font-size-32">{total}</span>
        <span className="text-accent font-size-14">
          {count} {countLabel}
        </span>
      </div>
      <div>
        <AreaGraph />
      </div>
    </div>
  );
}

const data = [
  {
    uv: 2000,
    pv: 2400,
    amt: 2400,
  },
  {
    uv: 1700,
    pv: 1398,
    amt: 2210,
  },
  {
    uv: 2200,
    pv: 9800,
    amt: 2290,
  },
  {
    uv: 1600,
    pv: 3908,
    amt: 2000,
  },
];

function AreaGraph() {
  return (
    // <ResponsiveContainer width="100%" height="100%">
    <AreaChart
      width={200}
      height={50}
      data={data}
      margin={{
        top: 10,
        right: 30,
        left: 0,
        bottom: 0,
      }}
    >
      <Area type="monotone" dataKey="uv" stroke="#f47b33" fill="#f47b33" />
    </AreaChart>
    // </ResponsiveContainer>
  );
}

function UpgradePlan({ className, planId = "1_basic_starter_plan" }) {
  const { data = {} } = useFetchPlanById(`${planId}_mx`);

  return (
    <div className={clsx("bg-white rounded-lg p-4", className)}>
      <div className="px-2 pt-2 mb-4">
        <h3 className="font-size-32 font-weight-bold">
          Obtén mas de 50 plantillas por solo:{" "}
        </h3>
        {/* <h3 className="font-size-28 font-weight-bold">
          Aprovecha el 50% de descuento en nuestros planes mensuales.
        </h3> */}
      </div>
      <div className="px-2 mb-5">
        <div className="mb-2">Usa los beneficios de STARTER desde</div>
        <span className="font-size-32 font-weight-bold ">
          {getPrice(data?.amount, data?.currency)}
        </span>{" "}
        <span className="font-size-20 text-muted ml-2">Al mes</span>
        {/* <div className="mt-2 ">
          <div className="text-muted mb-2">
            Vigencia al 15 de octubre del 2022
          </div>
          <span className="text-accent">¡Aprovecha la promoción! </span>
        </div> */}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center px-2 pb-2">
        <span className="text-accent text-underline mb-5 font-size-20 font-weight-bold">
          Mejora tu plan gratuito aquí
        </span>
        <Link
          className="w-100 font-size-20"
          component={Button}
          to="/plans/monthly"
          color="accent-100"
        >
          Mejorar
        </Link>
      </div>
    </div>
  );
}

function RequestDemo({ className, skuId = "basic_starter_plan" }) {
  const { t } = useTranslation("common");
  return (
    <div className={clsx("bg-white rounded-lg p-4", className)}>
      <div className="px-2 pt-2">
        <h3 className="font-size-32 font-weight-bold">
          {t("homePage.box3.0")}
        </h3>
        <div className="text-muted font-size-18 mt-4">
          {t("homePage.box3.1")}
        </div>
      </div>
      <div className="px-2 mt-4">
        <span className="font-size-32 font-weight-bold">
          Contract Lifecycle Management
        </span>
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center px-2 mt-5 pb-2">
        <DemoFormContainer
          buttonProps={{
            className: "w-100 mt-2 rounded font-size-20",
            size: "md",
            color: "accent-100",
          }}
        />
      </div>
    </div>
  );
}

function UploadDocument({ className }) {
  const { t } = useTranslation();

  return (
    <div className={clsx("bg-white rounded-lg", className)}>
      <Row className="h-100">
        <Col className="pr-0" md={4}>
          <img className="w-100 h-100" src={signImg} alt="" />
        </Col>
        <Col md={8} className="d-flex flex-column p-4 justify-content-center">
          <div className="px-2 pb-4">
            <h3 className="font-size-32 font-weight-bold">
              {t("homePage.box2.title")}
            </h3>
          </div>
          <div className="px-2">
            <div className="pb-4 font-size-18 text-muted">
              {t("homePage.box2.text.0")}
            </div>
            <div className="pb-4 font-size-18 text-muted">
              {t("homePage.box2.text.1")}
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center px-2">
            <Link
              className="text-accent text-underline pb-4 font-size-20 font-weight-bold"
              to="/tutorials"
            >
              {t("homePage.box2.button1")}
            </Link>
            <UploadPdfModal
              buttonProps={{
                className: "mt-2 font-size-20",
                color: "accent-100",
              }}
            >
              {t("actions.uploadDocument")}
            </UploadPdfModal>
          </div>
        </Col>
      </Row>
    </div>
  );
}

function PopularTemplatesContainer({ className }) {
  const { t } = useTranslation("common");
  const { data, isLoading } = usePublicTemplateList({
    currency: "mxn",
    page: 1,
    perPage: 3,
    jurisdiction: "mx",
    onlyTemplates: "true",

    sortBy: "mostPopular",
  });

  const [step, setStep] = React.useState(1);

  return (
    <>
      {step === 1 ? (
        <PopularTemplates
          title={t("homePage.box4.0")}
          viewMoreUrl="/templates/catalog"
        />
      ) : (
        <PopularTemplates
          title="Nuevas Plantillas Despachos"
          viewMoreUrl="/templates/lawyers"
          onlyExternal
        />
      )}
      <div className="newHome--popular---controls mt-2" hidden>
        <div className="controls">
          <div
            onClick={() => setStep(1)}
            className={step === 1 ? "active" : "noActive"}
          ></div>
          <div
            onClick={() => setStep(2)}
            className={step === 2 ? "active" : "noActive"}
          ></div>
        </div>
      </div>
    </>
  );
}

function PopularTemplates({ className, title, viewMoreUrl, onlyExternal }) {
  const { t } = useTranslation("common");
  const { data, isLoading } = usePublicTemplateList({
    currency: "mxn",
    page: 1,
    perPage: 3,
    jurisdiction: "mx",
    onlyTemplates: "true",
    onlyExternal,
    sortBy: "mostPopular",
  });

  return (
    <div className={clsx("bg-white rounded-lg p-4 children", className)}>
      <div className="px-2 pt-2 ">
        <h3 className="font-size-32 font-weight-bold">{title}</h3>
      </div>
      <div className="px-2 mt-5">
        {data?.map((template) => (
          <div className="mb-2">
            <MiniTemplateItem
              className="mb-4"
              id={template._id}
              name={template.name}
              image={
                onlyExternal ? template?.user?.office?.logo : template.image
              }
              subtitle={onlyExternal && template?.user?.office?.name}
              category={template?.categories?.[0]?.name || t("homePage.box4.3")}
            />
          </div>
        ))}
        {isLoading && (
          <div className="d-flex justify-content-center align-items-center mb-4">
            <Spinner />
          </div>
        )}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center px-2 pb-2 mt-3">
        <Link
          className="text-accent text-underline font-size-20 font-weight-bold"
          to={viewMoreUrl}
        >
          {t("homePage.box4.4")}
        </Link>
      </div>
    </div>
  );
}

function LawyerChild({ pic, bussinesName, template, category, id }) {
  return (
    <Link
      className={"HomeLawyersPopularTemplates--Container"}
      to={`/templates/${id}/edit`}
    >
      <div className="picPreview">
        <div
          className="UploadedImage__dashboardSettings"
          style={{
            backgroundImage: `url(${pic})`,
          }}
        ></div>
      </div>
      <div className="description2">
        <p className="bussinesName">
          {bussinesName?.length > 18
            ? bussinesName?.slice(0, 18) + "..."
            : bussinesName || ""}
        </p>
        <p className="name">
          {template?.length > 25
            ? template?.slice(0, 25) + "..."
            : template || ""}
        </p>
        <p className="category">{category}</p>
      </div>
    </Link>
  );
}
